import * as moment from 'moment';

import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'phoenix-comments',
  templateUrl: './comments.component.html',
  standalone: false,
})
export class CommentsComponent implements OnInit {
  @Output() save = new EventEmitter<FormGroup>();
  @Output() remove = new EventEmitter();
  @Input() comment!: FormGroup;
  @Input() disable = false;
  @Input() currentUser = '';

  datePipe = inject(DatePipe);

  editing = false;
  entry = new FormControl('');
  isNew = false;

  ngOnInit() {
    this.initializeComment();
  }

  initializeComment() {
    if (!this.comment) {
      this.comment = new FormGroup({
        name: new FormControl(this.currentUser ?? ''),
        timestamp: new FormControl(moment.utc().toISOString()),
        comment: new FormControl(''),
        edited: new FormControl(false),
      });
      this.isNew = true;
    }
  }

  get sameUser() {
    return this.comment.get('name')?.value === this.currentUser;
  }

  beginEdit() {
    if (!this.disable) {
      this.editing = true;
      this.comment.get('edited')?.setValue(!this.isNew);
      this.entry.patchValue(this.comment.get('comment')?.value);
    }
  }

  cancelEdit() {
    this.editing = false;
  }

  deleteComment() {
    if (!this.disable) {
      this.remove.emit(this.comment);
    }
  }

  addComment() {
    if (this.entry?.value?.trim() !== '') {
      this.editing = false;
      this.comment.get('comment')?.setValue(this.entry.value ?? '');
      this.comment.get('timestamp')?.setValue(moment.utc().toISOString());

      this.save.emit(this.comment);
      if (this.isNew) {
        this.resetComment();
      }
    }
  }

  formatDate(date: any) {
    let time;
    if (typeof date === 'string') {
      time = date;
    } else if (date instanceof Date) {
      time = this.datePipe.transform(date, 'medium');
    } else {
      time = moment.utc(date.toDate()).toISOString();
    }
    return time;
  }

  resetComment() {
    this.comment.reset({
      name: this.currentUser,
      timestamp: moment.utc().toISOString(),
      comment: '',
      edited: false,
    });
    this.isNew = true;
    this.entry.reset();
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      this.addComment();
      this.preventEvent(event);
    } else if (event.key === 'Escape') {
      this.cancelEdit();
      this.preventEvent(event);
    }
  }

  onKeyUp(event: KeyboardEvent) {
    this.preventEvent(event);
  }

  preventEvent(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }
}
